export enum CashFlowTransactionType {
  AR_RECEIPT = "AR_RECEIPT",
  AP_PAYMENT = "AP_PAYMENT",
  CASH_IN = "CASH_IN",
  CASH_OUT = "CASH_OUT",
}
